import type { FunctionalComponent, SVGAttributes } from 'vue'

export const PrimaryPlusIcon: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ cursor: 'pointer' }} {...props}>
      <path
        d="M8 5.2V10.8M5.2 8H10.8M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
        stroke={props.stroke || 'var(--colors-primary)'}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
